import queryClient from '@/config/queryClientProvider'
import { msalInstance } from '@/config/msal'
import { MsalProvider } from '@azure/msal-react'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { useThemeStore } from '@store/theme'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { BrowserRouter } from 'react-router-dom'
import { darkTheme, lightTheme } from './theme'
import GlobalSnackbar from './shared/components/GlobalSnackbar'
import GlobalDialog from './shared/components/Dialog'

import AppRoutes from '@/routes'
import { useEffect } from 'react'

function App() {
  const { mode } = useThemeStore()

  useEffect(() => {
    document.body.classList.remove('light-theme', 'dark-theme')
    document.body.classList.add(mode === 'light' ? 'light-theme' : 'dark-theme')
  }, [mode])

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={mode === 'light' ? lightTheme : darkTheme}>
        <CssBaseline />
        <BrowserRouter>
          <MsalProvider instance={msalInstance}>
            <AppRoutes />
            <GlobalSnackbar />
            <GlobalDialog />
          </MsalProvider>
        </BrowserRouter>
      </ThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}

export default App
